var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg023WaterHose = function Svg023WaterHose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M277.8 44.7C247.2 15.899 207.001 0 165 0 74.099 0 0 74.099 0 165c0 90.899 74.099 165 165 165 88.5 0 160.8-70.501 164.7-158.101-21.899-4.799-42.299-12.599-61.199-22.8C269.099 154.2 270 159.6 270 165c0 57.9-47.1 105-105 105S60 222.9 60 165 107.1 60 165 60c28.801 0 55.201 11.7 74.099 30.899C277.5 129 334.6 150 398.2 150H422V90h-31.099c-41.4 0-81.601-16.201-113.101-45.3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 165,
    r: 15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165 90c-41.353 0-75 33.647-75 75s33.647 75 75 75 75-33.647 75-75c0-41.277-33.582-75-75-75m0 120c-24.814 0-45-20.186-45-45s20.186-45 45-45 45 20.186 45 45-20.186 45-45 45M60 329.053C35.832 313.531 15.374 292.846.057 268.537L.108 360H60zM43.242 512l14.896-122H1.76l14.998 122zM452 90h60v60h-60z"
  })));
};
export default Svg023WaterHose;